import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis";

const initialState = {
  keyServicesData: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const getKeyServices = createAsyncThunk(
    'getKeyServices',
    async (params, { rejectWithValue }) => {
        const api = await getAxiosInstance();
        try {
            const response = await api.get(`page/key-facts`);
            return response.data?.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const usekeyservicesSlice = createSlice({
    name: "usekeyservices",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getKeyServices.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getKeyServices.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.keyServicesData = action.payload;
            })
            .addCase(getKeyServices.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export default usekeyservicesSlice.reducer;